"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDBEMembers = exports.getBusMembers = exports.getRailMembers = exports.getAPTAMembers = exports.APTAMemberTypes = void 0;
const helpers_1 = require("./helpers");
const APTAMembers_1 = __importDefault(require("../ESRIResponses/APTAMembers"));
const BusMembers_1 = __importDefault(require("../ESRIResponses/BusMembers"));
const RailMembers_1 = __importDefault(require("../ESRIResponses/RailMembers"));
const constants_1 = require("../constants");
var APTAMemberTypes;
(function (APTAMemberTypes) {
    APTAMemberTypes["DBE_MEMBER"] = "DBE_MEMBER";
    APTAMemberTypes["APTA_MEMBER"] = "APTA_MEMBER";
    APTAMemberTypes["BUS_MANU"] = "BUS_MANU";
    APTAMemberTypes["RAIL_MANU"] = "RAIL_MANU";
})(APTAMemberTypes = exports.APTAMemberTypes || (exports.APTAMemberTypes = {}));
// TODO: Write Unit Tests
function genMemberQuery(state, congress) {
    return (requestData) => {
        let query = "";
        const { type } = requestData;
        switch (type) {
            case constants_1.LegislatorTypes.STATE_SUM: {
                const { stateAbbrev } = requestData;
                query = `${state} = '${stateAbbrev}'`;
                break;
            }
            case constants_1.LegislatorTypes.SENATE: {
                const { stateAbbrev } = requestData;
                query = `${state} = '${stateAbbrev}'`;
                break;
            }
            case constants_1.LegislatorTypes.HOUSE: {
                const { stateAbbrev, district } = requestData;
                query = `${state} = '${stateAbbrev}' AND ${congress} = '${district}'`;
                break;
            }
            case constants_1.LegislatorTypes.SLDL: {
                const { builtID, stateAbbrev } = requestData;
                const lowerBuild = builtID.toLowerCase();
                if (lowerBuild.includes("at-large")) {
                    query = `${state} = '${stateAbbrev}'`;
                }
                else {
                    query = `sldl = '${builtID}'`;
                }
                break;
            }
            case constants_1.LegislatorTypes.SLDU: {
                const { builtID, stateAbbrev } = requestData;
                const lowerBuild = builtID.toLowerCase();
                if (lowerBuild.includes("at-large")) {
                    query = `${state} = '${stateAbbrev}'`;
                }
                else {
                    query = `sldu = '${builtID}'`;
                }
                break;
            }
        }
        return query;
    };
}
function getAPTAMembers(requestData, token) {
    return new Promise((resolve, reject) => {
        const query = genMemberQuery("adr_phys_state_ext", "CD")(requestData);
        // const url =
        //   "https://services2.arcgis.com/MGS8P397fp3TUR2w/arcgis/rest/services/netforum_members_2018/FeatureServer/0";
        const url = "https://services2.arcgis.com/MGS8P397fp3TUR2w/arcgis/rest/services/netforum_members_2023/FeatureServer/259";
        helpers_1.runQuery(url, query, token)
            .then((queryResult) => {
            let theParsedMembers = new APTAMembers_1.default(queryResult);
            resolve(theParsedMembers);
        })
            .catch((error) => {
            reject(error);
        });
    });
}
exports.getAPTAMembers = getAPTAMembers;
function getRailMembers(requestData, token) {
    return new Promise((resolve, reject) => {
        const query = genMemberQuery("State", "CD113FP")(requestData);
        const url = "https://services2.arcgis.com/MGS8P397fp3TUR2w/arcgis/rest/services/Rail_manu_2023/FeatureServer/311";
        helpers_1.runQuery(url, query, token)
            .then((queryResult) => {
            let theParsedMembers = new RailMembers_1.default(queryResult);
            resolve(theParsedMembers);
        })
            .catch((error) => {
            reject(error);
        });
    });
}
exports.getRailMembers = getRailMembers;
function getBusMembers(requestData, token) {
    return new Promise((resolve, reject) => {
        const query = genMemberQuery("State", "CD113FP")(requestData);
        const url = "https://services2.arcgis.com/MGS8P397fp3TUR2w/arcgis/rest/services/Bus_manu_2023/FeatureServer/325";
        helpers_1.runQuery(url, query, token)
            .then((queryResult) => {
            let theParsedMembers = new BusMembers_1.default(queryResult);
            resolve(theParsedMembers);
        })
            .catch((error) => {
            reject(error);
        });
    });
}
exports.getBusMembers = getBusMembers;
function getDBEMembers(requestData, token) {
    return new Promise((resolve, reject) => {
        const query = genMemberQuery("adr_phys_state_ext", "CD")(requestData);
        const url = "https://services2.arcgis.com/MGS8P397fp3TUR2w/arcgis/rest/services/APTA_Members_(DBE)/FeatureServer/259";
        helpers_1.runQuery(url, query, token)
            .then((queryResult) => {
            let theParsedMembers = new APTAMembers_1.default(queryResult);
            resolve(theParsedMembers);
        })
            .catch((error) => {
            console.error("the error in package", error);
            reject(error);
        });
    });
}
exports.getDBEMembers = getDBEMembers;
